import { createContext } from "react";

export const NotesContext = createContext();

export const NotesProvider = NotesContext.Provider;
export const NotesConsumer = NotesContext.Consumer;
